import React from "react";
import styled from "styled-components";
import {device} from "../../../../styles/BreakPoints";
import NoteProjectItem from "./noteProjectItem/NoteProjectItem";

const NoteProjects = () => {
  const projectList = [
    {
      name: "PC Builder",
      description: "An Online PC Builder estimating web application.",
      techStacks: [
        "Next.js",
        "TypeScript",
        "Redux-toolkit",
        "Express.js",
        "Mongoose",
        "MongoDb",
      ],
      links: {
        live: "https://pctech.vercel.app/",
        frontend: "https://github.com/tusharahmmed/next-pc-builder",
      },
    },
    {
      name: "Book Store",
      description: "An Online book store web application.",
      techStacks: [
        "React",
        "TypeScript",
        "Redux-toolkit",
        "Express.js",
        "Mongoose",
        "MongoDb",
        "Zod",
        "JWT",
      ],
      links: {
        live: "https://digital-books-store.netlify.app/",
        frontend: "https://github.com/tusharahmmed/book-library-frontend",
      },
    },
    {
      name: "Music Library Backend",
      description: "A backend server for a music library.",
      techStacks: [
        "Node.js",
        "Authentication",
        "Authorization",
        "Express.js",
        "Postgres",
        "Prisma",
        "Zod",
        "JWT",
      ],
      links: {
        live: "m36-music.vercel.app",
        frontend: "https://github.com/tusharahmmed/m360-music-library-backend",
      },
    },
    {
      name: "Car Shop",
      description:
        "An Online Car Selling web application.It has user login and registration functionality.",
      techStacks: ["Express.js", "React.js", "Firebase", "MongoDb"],
      links: {
        live: "https://carz-shop.web.app/",
        frontend: "https://github.com/tusharahmmed/carz-frontend",
      },
    },
    {
      name: "Ask Me",
      description: "An Online Question and Answering web application.",
      techStacks: [
        "Styled Components",
        "Express.js",
        "React.js",
        "Firebase",
        "MongoDb",
      ],
      links: {
        live: "https://ask-me-society.web.app/",
        frontend: "https://github.com/tusharahmmed/ask-me-society",
      },
    },
    {
      name: "Symlex Vpn",
      description: "An Online Question and Answering web application.",
      techStacks: ["HTML", "CSS", "Bootstrap"],
      links: {
        live: "https://symlex.netlify.app/",
        frontend: "https://github.com/tusharahmmed/symlex-vpn",
      },
    },
    {
      name: "Realtor",
      description: "Real Estate web application for rent or bye homes.",
      techStacks: ["Next.js", "Chakra Ui", "Axios", "Rapid Api"],
      links: {
        live: "https://home-rental.vercel.app/",
        frontend: "https://github.com/tusharahmmed/home-rental",
      },
    },
    {
      name: "Multikart",
      description: "Landing page design with React.",
      techStacks: ["React.js", "JavaScript", "React Reveal"],
      links: {
        live: "https://multikart-landing-page.netlify.app/",
        frontend: "https://github.com/tusharahmmed/multikart-landing-page",
      },
    },
    {
      name: "Willcox",
      description: "Landing page design for a power station.",
      techStacks: ["React.js", "Vercel", "Styled Components"],
      links: {
        live: "https://willcox-energy.vercel.app//",
        frontend: "https://github.com/tusharahmmed/willcox-energy",
      },
    },
  ];

  return (
    <Section id="project">
      <Title>Other Noteworthy Projects</Title>
      <ProjectList>
        {projectList?.length > 0 &&
          projectList.map((item, i) => {
            return <NoteProjectItem key={i} data={item} />;
          })}
      </ProjectList>
    </Section>
  );
};

export default NoteProjects;

const Section = styled.section`
  margin: 0px auto;
  padding: 100px 0px;
  max-width: 1000px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2`
  font-size: clamp(24px, 5vw, var(--fz-heading));
`;

const ProjectList = styled.ul`
  list-style: none;
  padding: 0px;
  margin: 50px 0px 0px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  position: relative;

  @media ${device.mdL} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media ${device.mdS} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
